import { createContext } from 'react';

const ResetPasswordsContext = createContext();

export default ResetPasswordsContext; 